(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-hidden','animate');
      // this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              $('.product-recommendations--loaded ul').slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 3,
                dots:false,
                arrows:true,
                prevArrow: '<button class="slide-arrow prev-arrow"><svg id="arrow-left" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><rect id="Rectangle_82" data-name="Rectangle 82" width="32" height="32" fill="rgba(255,255,255,0.01)"/><path id="Path_67" data-name="Path 67" d="M3.866,16h24" fill="none" stroke="#63666a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.333"/><path id="Path_68" data-name="Path 68" d="M11.866,24l-8-8,8-8" fill="none" stroke="#63666a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.333"/></svg></button>',
                nextArrow: '<button class="slide-arrow next-arrow"><svg id="arrow-left" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><rect id="Rectangle_82" data-name="Rectangle 82" width="32" height="32" fill="rgba(255,255,255,0.01)"/><path id="Path_67" data-name="Path 67" d="M27.866,16h-24" transform="translate(0.268)" fill="none" stroke="#63666a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.333"/><path id="Path_68" data-name="Path 68" d="M3.866,24l8-8-8-8" transform="translate(16.268)" fill="none" stroke="#63666a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.333"/></svg></button>',
                responsive: [
                  {
                    breakpoint: 992,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                      margin:10
                  	}
                  },
                  {
                    breakpoint: 481,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                  	}
                  }
                ]
              });
              $('.qvproductimages').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots:false,
                arrows:false
              });
              $('.product-recommendations--loaded .quick-view').click(function(){
                  var tab_id = $(this).attr('data-handle');
                  $('.quickview-popup').removeClass('current');
                  $("#"+tab_id).addClass('current');
                  $('body').addClass('modal-open');
                  $('.qvproductimages').slick('setPosition');
              });     
              
               $('.addtocart.qv-add-button').click(function(){
                $('body').removeClass('modal-open');
                $('.quickview-popup').removeClass('current');
              });

              const defaults = {
                addToCart: '.js-ajax-add-to-cart', // classname
              };
              
              const addToCart = document.querySelectorAll(defaults.addToCart);
              
              for (let i = 0; i < addToCart.length; i++) {
                addToCart[i].addEventListener('click', function(event) {
                  event.preventDefault(); 
                  const formID = $(this).parents('form').attr('id');
                  addProductToCart(formID);
                  setTimeout(function(){
                    openCartDrawer();
                    openCartOverlay();
                  }, 2000);
                });
              
              }
              
              
              function addProductToCart(formID) {
                var form = $('#' + formID).serialize();
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  dataType: 'json',
                  data: $('#' + formID)
                  .serialize(),
              
                  success: function(result){
                    $('#' + formID).find('.drawer-btn.product-form__submit').text('Added');
                    setTimeout(function(){
                      $('#' + formID).find('.drawer-btn.product-form__submit').text('Add +');
                    }, 2000);
                    
                    addToCartOk(result);
                  }
                });
              }
              
              
              function addToCartOk(product) {
                openCartDrawer();
                fetchCart();
              }
              
              
              function openCartDrawer() {
                cartDrawer.classList.add('is-open');
                document.querySelector('body').classList.add('cart-drawer-open');
              
              }
              
              function openCartOverlay() {
                cartOverlay.classList.add('is-open');
                htmlSelector.classList.add('is-locked');
              }
              
              
              function fetchCart() {
                $.ajax({
                  type: 'GET',
                  url: '/cart.js',
                  dataType: 'json',
                  success: function(cart) {
                    onCartUpdate(cart);
                    if (cart.item_count === 0) {
                      cartDrawerContent.innerHTML = '';
                      cartDrawerContent.innerHTML = '<p>Cart is empty</p><div class="continue-shopping-btn"><a href="/collections/all">Continue Shopping</a></div>';
                      checkoutButton.classList.add('is-hidden');        
                      $('.continue-shopping-btn a').click(function(e){
                        // e.preventDefault();
                        closeCartDrawer();
                        closeCartOverlay();
                      });
                    } else {
                      renderCart(cart);
                      checkoutButton.classList.remove('is-hidden');
                      
                    }     
                    
                  },
                });
              }
              
              function closeCartDrawer() {
                cartDrawer.classList.remove('is-open');
                document.querySelector('body').classList.remove('cart-drawer-open');
              }
              
              function closeCartOverlay() {
                cartOverlay.classList.remove('is-open');
                htmlSelector.classList.remove('is-locked');
              }
              
              
              function renderCart(cart) {
                var threshold = $('.Cart_ShippingNotice').data('threshold');
                if(threshold != undefined){
                  if(cart.total_price >= threshold){
                    $('.Cart_ShippingNotice .Drawer__Container').html('<h4> Congrats! You get 2 free samples.</h4>');
                  }else{
                    var remain = threshold - cart.total_price;
                    $('.Cart_ShippingNotice .Drawer__Container').html('<h4>'+Shopify.formatMoney(remain)+' away from 2 free samples</h4>');
                  }
                }
              
                clearCartDrawer();
              
                if(cart.items.length > 0){
                  $('.ajax-cart-drawer__cart-total').html(Shopify.formatMoney(cart.total_price));
                  $('.ajax-cart-drawer').removeClass('empty-cart');
              
                  if(cartCounter == undefined){
                    $('.js-ajax-cart-drawer-trigger').append('<div class="cart-count-bubble"><span aria-hidden="true" class="js-ajax-cart-counter">'+cart.item_count+'</span></div>')
                  }
              
                }else{
              
                }
              
              
                count = 0;
                cart.items.forEach(function(item, index) {
                  const productTitle = '<div class="ajax-cart-item__title">' + item.product_title + '</div>';
                  
                  const productProperty = ''+item.properties["line-item"]+''; 
              
                  if (item.selling_plan_allocation != null) {
                    var productSellingPlan = '<div class="ajax-cart-item_selling_plan">'+item.selling_plan_allocation.selling_plan.name+'</div>';   
                  }else{
                    var productSellingPlan = '<div class="ajax-cart-item_selling_plan"></div>';   
                  }
                  
                  
                  
                  if ( item.final_price > 0) {
                    var variantTitle = '<div class="ajax-cart-item_variant__title">' + item.variant_title + '</div>';
                  }else{
                    var variantTitle = '<div class="ajax-cart-item_variant__title"></div>';
                  }
                  const productImage = '<img class="ajax-cart-item__image" src="' + item.image + '" >';
                  const productPrice = '<div class="ajax-cart-item__price">' + Shopify.formatMoney(item.line_price) + '</div>';    
                  
                  // if ( typeof item.properties['line-item'] !== "undefined") {
                  if ( item.final_price > 0) {
                    //if ( !item.properties ) {
                    //  if (typeof item.properties == 'undefined') { 
                    var productQuantity = '<div class="ajax-cart-item__quantity">' + item.quantity + '</div>';
                    var productQuantity = '<div class="ajax-cart-item__quantity"><quantity-input class="quantity" data-line="' + Number(index + 1) + '">'+
                        '<button class="quantity__button no-js-hidden js-ajax-cart-minus" name="minus" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="11.616" height="1.872" viewBox="0 0 11.616 1.872"><path id="Path_78" data-name="Path 78" d="M6.456-7.08H1.584v1.872H13.2V-7.08H6.456Z" transform="translate(-1.584 7.08)" fill="#63666a"/></svg></button>'+
                        '<input class="quantity__input js-ajax-item__quantity" type="number" name="updates[]" id="Quantity-'+index+'" value="'+item.quantity+'" form="ajax-cart-item__quantity'+index+'">'+
                        '<button class="quantity__button no-js-hidden js-ajax-cart-plus" name="plus" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="11.616" height="11.616" viewBox="0 0 11.616 11.616"><path id="Path_77" data-name="Path 77" d="M6.456-11.952V-7.08H1.584v1.872H6.456V-.336H8.328V-5.208H13.2V-7.08H8.328v-4.872Z" transform="translate(-1.584 11.952)" fill="#63666a"/></svg></button></div>'+
                        '</quantity-input>';
              
              
                  }else{
                    var productQuantity = '<div class="ajax-cart-item__quantity">' + item.quantity + '</div>';
                    var productQuantity = '<div class="ajax-cart-item__quantity"><quantity-input class="quantity" data-line="' + Number(index + 1) + '">'+
                        '<button class="quantity__button no-js-hidden js-ajax-cart-minus" name="minus" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="11.616" height="1.872" viewBox="0 0 11.616 1.872"><path id="Path_78" data-name="Path 78" d="M6.456-7.08H1.584v1.872H13.2V-7.08H6.456Z" transform="translate(-1.584 7.08)" fill="#63666a"/></svg></button>'+
                        '<input class="quantity__input js-ajax-item__quantity" type="number" name="updates[]" id="Quantity-'+index+'" value="'+item.quantity+'" form="ajax-cart-item__quantity'+index+'">'+
                        '<button class="quantity__button no-js-hidden " type="button" disabled><svg xmlns="http://www.w3.org/2000/svg" width="11.616" height="11.616" viewBox="0 0 11.616 11.616"><path id="Path_77" data-name="Path 77" d="M6.456-11.952V-7.08H1.584v1.872H6.456V-.336H8.328V-5.208H13.2V-7.08H8.328v-4.872Z" transform="translate(-1.584 11.952)" fill="#63666a"/></svg></button></div>'+
                        '</quantity-input>';
              
                  }
              
              
                  const productRemove = '<div data-vid="'+ item.variant_id +'" class="ajax-cart-item__remove ' + defaults.removeFromCartNoDot + '" data-line="' + Number(index + 1) + '"><svg xmlns="http://www.w3.org/2000/svg" width="24.092" height="24.092" viewBox="0 0 24.092 24.092"><g id="Group_526" data-name="Group 526" transform="translate(-1.81 -1.81)"><path id="Path_91" data-name="Path 91" d="M21.818,15.286l-6.532,6.532" transform="translate(-4.695 -4.695)" fill="none" stroke="#63666a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/><g id="Group_525" data-name="Group 525"><path id="Path_90" data-name="Path 90" d="M14.88,26.426A11.546,11.546,0,1,0,3.333,14.88,11.546,11.546,0,0,0,14.88,26.426Z" transform="translate(-1.023 -1.023)" fill="none" stroke="#63666a" stroke-linejoin="round" stroke-width="1"/><path id="Path_92" data-name="Path 92" d="M15.286,15.286l6.532,6.532" transform="translate(-4.695 -4.695)" fill="none" stroke="#63666a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/></g></g></svg></div>';
              
                  const concatProductInfo = '<div class="ajax-cart-item__single '+productProperty+'" data-variant-title="'+ item.variant_title +'" data-quantity="'+ item.quantity +'" data-product-id="'+ item.product_id +'" data-id="'+ item.id +'" id="pro_'+ item.id + '" data-line="' + Number(index + 1) + '"><div class="ajax_pro_img">' + productImage +'</div><div class="ajax_pro_info"><div class="ajax_cart_info">'+ productTitle +  variantTitle + productSellingPlan + '</div><div class="ajax_cart_property"></div><div class="ajax_pro_btm"><div class="ajax_pro_left">' + productQuantity + productRemove +'</div><div class="ajax_pro_right">' + productPrice + '</div></div></div></div>';
                
                  cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo;
              
                  
                  $('.ajax-cart-related_product ul li').each(function(){
                    var ProductID = $(this).data('product-id');
                    if(item.id == ProductID){
                      var ProductQuantity = $('.ajax-cart-item__single[data-id="'+item.id+'"]').data('quantity');
                      if($(this).find('.product-form__buttons button').text() == 'Added'){
                        $(this).find('.product-form__buttons button').text('Added('+ProductQuantity+')');
                      }
                    }
                  });
              
                  removeFromCart = document.querySelectorAll(defaults.removeFromCart);
                  updateCart = document.querySelectorAll('.js-ajax-item__quantity');
              
                  for (let i = 0; i < removeFromCart.length; i++) {
                    removeFromCart[i].addEventListener('click', function() {
                      const line = this.getAttribute('data-vid');
                      var product_line = $('#pro_40572742598864').attr('data-vid');
                      setTimeout(function () {
                        if(product_line == line){
                          $('#60-day-money-back-guarantee-5').prop('checked', false);
                        }
                      }, 1000);
                      var variantId = $(this).data("vid");
                      changeItem(variantId,0);
                      changeItem(line);
                    });
                  }
              
                  for (let i = 0; i < updateCart.length; i++) {
                    updateCart[i].addEventListener('change', function() {
                      const line = this.parentNode.getAttribute('data-line');
                      const val = this.value;
                      updateItem(line, val);
                    });
                  }
              
                  if(item.final_price > 0){
                    count++;
                  }
                });
              
              }              
              
              $('.quickview-close').click(function(){
                $('body').removeClass('modal-open');
                $('.quickview-popup').removeClass('current');
              });
              
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
